import * as $ from 'jquery';

function initAZListController() {
  if ($(".a-z-list").length > 0) {

    $(".a-z-list__list-item:not(.a-z-list__list-item--disabled) a").click(function (event) {
      event.preventDefault();

      var letter : string = $(this).text().toUpperCase();

      $('html, body').animate({
        scrollTop: ($(".a-z-list__cao-container[data-letter='" + letter + "']")).offset().top + 'px'
      });

      return false;
    });
  }
}

export { initAZListController };